interface PROPS {
  text: string;
  class_name?: string;
}

export function G_DRAG_AND_DROP__area_with_label({ text, class_name = '' }: PROPS) {
  return (
    <div
      className={`relative  flex-center
          size-full 
       rounded-xl 
      pointer-events-none
      transition-colors
      ${class_name}
    `}
    >
      <p className="font-semibold text-component-item-foreground text-lg truncate drop-shadow-[2px_2px_0_rgba(0,0,0,1)]">{text}</p>
    </div>
  );
}
